import React, { Component } from 'react';
import './Home.css';
import Resume from '../assets/img/Andy.pdf';

export default class Home extends Component {

  componentDidMount() {
    this.props.heightUpdate(this.divElement.clientHeight);
    window.addEventListener('scroll', (e) => {
      var scrolled = window.pageYOffset;
      const background = document.getElementById('home-background');
      background.style.top = + (scrolled * 0.2) + 'px';
    });
  }

  render() {
    return(
      <div 
        id="home-container" 
        className="home-container"
        ref={ (divElement) => this.divElement = divElement}
      >
        <div className="home-overlay">
          <div id='home-background' className='home-background'></div>
          <h1 className="name">ANDY LIANG</h1>
          <ul className="desc-list">
            <li className="desc">Software Engineer.</li>
            <li className="desc">Full Stack Developer.</li>
            <li className="desc pro-links">
              <a href={Resume} target='_blank' rel="noopener noreferrer"><span className="far fa-file-alt"></span></a>
              <a href='https://github.com/aliang6/' target='_blank' rel="noopener noreferrer"><span className="fab fa-github"></span></a>
              <a href='https://www.linkedin.com/in/andy-liang-677167127/' target='_blank' rel="noopener noreferrer"><span className="fab fa-linkedin-in"></span></a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Home/Home.js